import regionsConfig from './regions.json';
import statesConfig from './states.json';
import countiesConfig from './counties.json';
import dataTypesConfig from './dataTypes.json';
import geoTypesConfig from './geographyTypes.json';
import dataService from '../services/data.service';

// apply the default properties to the data objects if that property is missing
function setDefaults(data, defaults) {
    data.forEach(c => {
        for (const prop in defaults) {
            if (!c[prop]) {
                c[prop] = [...defaults[prop]];
            }
        }
    });
}

setDefaults(regionsConfig.regions, regionsConfig.defaults);
setDefaults(statesConfig.states, statesConfig.defaults);
setDefaults(countiesConfig.counties, countiesConfig.defaults);

regionsConfig.regions.sort((a, b) => a.label.localeCompare(b.label));
statesConfig.states.sort((a, b) => a.label.localeCompare(b.label));
countiesConfig.counties.sort((a, b) => a.state.localeCompare(b.state) || a.label.localeCompare(b.label));

// update county label to put the state first followed by the name. This reflects the sorting order
countiesConfig.counties.forEach(county => {
    county.label = `${county.state} - ${county.label}`;
});

const config = {
    idField: "id",
    regions: regionsConfig.regions,
    states: statesConfig.states,
    counties: countiesConfig.counties,
    dataTypes: dataTypesConfig.types,
    geographyTypes: geoTypesConfig.types
};

export { config };
